var _path, _path2, _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuantityStepperPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 56,
    viewBox: "0 0 150 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1H134C142.284 1 149 7.71573 149 16V40C149 48.2843 142.284 55 134 55H16C7.71573 55 1 48.2843 1 40V16C1 7.71573 7.71573 1 16 1Z",
    stroke: "#D4DBE9",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8281 28.5391H17.1719C16.8906 28.5391 16.6328 28.3047 16.6328 28C16.6328 27.7187 16.8672 27.4609 17.1719 27.4609H29.8281C30.1094 27.4609 30.3672 27.6953 30.3672 28C30.3672 28.2812 30.1094 28.5391 29.8281 28.5391Z",
    fill: "#284993"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 1,
    width: 54,
    height: 54,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 1,
    width: 54,
    height: 54,
    stroke: "#D4DBE9",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_quantity_stepper_pill)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.062 27.4844H127.039V21.4375C127.039 21.1562 126.805 20.8984 126.5 20.8984C126.219 20.8984 125.961 21.1328 125.961 21.4375V27.4844H119.937C119.656 27.4844 119.398 27.7187 119.398 28.0234C119.398 28.3047 119.633 28.5625 119.937 28.5625H125.984V34.5625C125.984 34.8437 126.219 35.1016 126.523 35.1016C126.805 35.1016 127.062 34.8672 127.062 34.5625V28.5391H133.062C133.344 28.5391 133.602 28.3047 133.602 28C133.602 27.7187 133.344 27.4844 133.062 27.4844Z",
    fill: "#284993"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_quantity_stepper_pill"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(119 20.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuantityStepperPill);
export default __webpack_public_path__ + "static/media/quantity-stepper-pill.dad0773a8399c3da62164e73b0f5cbba.svg";
export { ForwardRef as ReactComponent };